export const en = {
  'ui-confirm': {
    close: 'Close'
  }
};
